import data from '../data/knownCities.json';
import type {KnownCitiesFile, KnownCity} from '../interfaces/KnownCity';

// A ?city= (or shortcode city="…") landing used to start with Google: load the geocoding
// library, geocode the name, then search. On phones that was 0.8 s at the median between
// mount and the first request (rrm_startup, 5–11 Oct 2026). The cities people land on are
// our own links, and our city table carries each city's centre, so a known city resolves here,
// synchronously, and only an unknown name still goes to Google.

const cities = (data as KnownCitiesFile).cities;

/**
 * The lookup key of a city name as it arrives in the URL: percent-decoded (a malformed escape
 * keeps the raw text), trimmed, lower-case, diacritics folded (ä→a, ö→o, å→a), runs of spaces,
 * underscores and hyphens as one hyphen. So `jyv%C3%A4skyl%C3%A4`, `jyvaskyla` and `JYVÄSKYLÄ`
 * are one key. The generator (src/services/knownCitiesTable.ts) applies this same function.
 */
export function normaliseCitySlug(raw: string): string {
    let s = raw;
    try { s = decodeURIComponent(raw); } catch { /* malformed escape: use the raw text */ }
    s = s.replace(/\+/g, ' ').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[\s_-]+/g, '-');
}

export function lookupKnownCity(raw: string | undefined | null): KnownCity | undefined {
    if (!raw) return undefined;
    const key = normaliseCitySlug(raw);
    if (!key) return undefined;
    const hit = Object.prototype.hasOwnProperty.call(cities, key) ? cities[key] : undefined;
    return hit ? {lat: hit.lat, lng: hit.lng, label: hit.name, searchCity: hit.name} : undefined;
}
